import { Children, cloneElement, Fragment, isValidElement } from 'react';
import type { ReactElement, ReactNode } from 'react';
import type { RouteProps } from 'react-router-dom';

import {
  isMissionRoutePath,
  toSubMissionRoutePath,
} from './mission-space.util';

const isRoute = (node: ReactNode): node is ReactElement<RouteProps> =>
  isValidElement<RouteProps>(node);

// The mission page routes are mounted under the base of a sub-mission nested
// in its collaboration too: each mission route gets its nested twin, the
// layout routes keeping both.
export const withSubMissionRoutes = (routes: ReactNode): ReactNode[] =>
  Children.toArray(routes).flatMap((route) => {
    if (!isRoute(route)) {
      return [route];
    }

    if (route.type === Fragment) {
      return withSubMissionRoutes(route.props.children);
    }

    const { path, children } = route.props;

    if (!path) {
      return [
        cloneElement(route, undefined, ...withSubMissionRoutes(children)),
      ];
    }

    return isMissionRoutePath(path)
      ? [
          route,
          cloneElement(route, {
            key: `${String(route.key)}-sub-mission`,
            path: toSubMissionRoutePath(path),
          }),
        ]
      : [route];
  });
